// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"ChangePassword__wrapper___3Nnzy","logo":"ChangePassword__logo___2kYK7","link":"ChangePassword__link___3XvbW","button":"ChangePassword__button___2QLzP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChangePassword/ChangePassword.scss
// module id = kz8f
// module chunks = 0